import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { currentLocale } from 'src/app/locale.config';

@Component({
  selector: 'app-nav-icon',
  templateUrl: './nav-icon.component.html',
  styleUrls: ['./nav-icon.component.scss'],
  standalone: false,
})
export class NavIconComponent {
  @Input({ required: true }) icon!: string | undefined;
  @Input({ required: true }) route!: string | undefined;
  @Input() localize = true;
  @Input() displayText = '';
  @Input() hasDisplayText = false;

  constructor(private router: Router) {}

  get isActive() {
    return this.router.url.includes(this.route as string);
  }

  get link() {
    const localizedRoute = `${currentLocale()}${this.route}`;
    const route = `${this.route}`;
    return this.localize ? localizedRoute : route;
  }
}
